import { render, staticRenderFns } from "./menuItem-single.vue?vue&type=template&id=633e59c6&scoped=true"
import script from "./menuItem-single.vue?vue&type=script&lang=js"
export * from "./menuItem-single.vue?vue&type=script&lang=js"
import style0 from "./menuItem-single.vue?vue&type=style&index=0&id=633e59c6&prod&lang=scss"
import style1 from "./menuItem-single.vue?vue&type=style&index=1&id=633e59c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633e59c6",
  null
  
)

export default component.exports